import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.tournaments.loaded,
    props.tournaments.tournament,
    props.user.isAuth,
    (loaded, tournament, isAuth) => {
        return {
            loaded,
            tournament,
            isAuth
        }
    }
)